// src/listeners/holdingSessionEventListener.ts
import {useAuthStore} from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import useStore from "@src/stores/store";
import {db} from "@src/services/db";
import "@src/services/echo";
import MessageService from "@src/services/message";
import NotificationsService from "@src/services/notifications";

export const HoldingSessionListener = () => {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();
    const store = useStore();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets.private(`user.${userId}`).listen(".NewHoldingSession", async (event: any) => {
        const s = event?.session;
        if (!s?.id) return;

        const sid = Number(s.id);

        // se estava aberto, fecha
        const selected = sessionStore.selectedSession as any;
        const wasSelected = Number(selected?.id) === sid;

        // Evento de "voltou pra espera" chegando atrasado/fora de ordem para uma
        // sessão que o operador já assumiu localmente (status 'active') — ignora,
        // senão fecha o chat que acabou de ser aberto (ex.: FooterArea.initSession).
        if (wasSelected && String(selected?.status ?? "") === "active") {
            return;
        }

        try {
            // get no historico de messages do bot
            const resp = await MessageService.getSessionMessagesOld(sid);

            const hasNewMessage = !wasSelected;

            const messages = Array.isArray(resp?.data)
                ? resp.data.map((message: any) => ({
                    ...message,
                    chat_session_id: Number(message.chat_session_id ?? sid),
                }))
                : [];

            // salva todas as messages
            await db.transaction("rw", db.sessions, db.messages, async () => {
                if (messages.length > 0) {
                    await db.messages.bulkPut(messages);
                }

                await db.sessions.put({
                    ...s,
                    status: "hold",
                    operator_id: null,
                    updated_at: new Date().toISOString(),
                    has_new_messages: hasNewMessage
                } as any);
            });

            if (wasSelected) {
                // atualiza a sidebar
                store.activeSidebarComponent = "holding";
                sessionStore.clearSession();
            } else {
                NotificationsService.notify('Novo atendimento em espera!');
            }
        } catch (e) {
            console.error("❌ erro no listener NewHoldingSession", e);
        }
    });
};